module.exports = __webpack_public_path__ + "img/luxury-tabbed-search-filter-infiniti.31c9b269.png";